(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  function run() {
    for (const filterButton of document.querySelectorAll('[data-convx-mobile-filter]')) {
      filterButton.addEventListener('click', expandAccordion.bind(null, filterButton));
    }
  }

  function expandAccordion(filterButton) {
    for (const targetAccordion of document.querySelectorAll(`[data-id="${filterButton.dataset.convxMobileFilter}"]`)) {
      for (const otherAccordion of targetAccordion.parentElement.children) {
        otherAccordion.removeAttribute('open');
        otherAccordion.setAttribute('aria-expanded', 'false');
      }

      targetAccordion.setAttribute('open', '');
      targetAccordion.setAttribute('aria-expanded', 'true');
    }
  }
})();